<div class="header-container" id="header-main">
  <!-- Hamburger for mobile -->
  <button class="hamburger-btn mobile-only" (click)="onHamburgerClick()" aria-label="Open menu" id="header-hamburger">
    <i class="fas fa-bars"></i>
  </button>
  <!-- Top header with company info -->
  <div class="top-header" id="header-top">
    <div class="company-info" id="header-company-info">
      <img *ngIf="currentUser?.company_logo" [src]="currentUser?.company_logo" alt="Logo" class="company-logo" id="header-company-logo">
      <img *ngIf="!currentUser?.company_logo" src="assets/images/innovadoc-logo.png" alt="Innovadoc IA"
        class="default-logo" id="header-default-logo">
      <h1 class="company-name" id="header-company-name">{{ currentUser?.company || 'Innovadoc IA' }}</h1>
    </div>

    <div class="header-actions" id="header-actions">
      <!-- Notifications -->
      <div class="notification-container" id="header-notification-container">
        <button class="notification-btn" (click)="toggleNotifications()" id="header-notification-btn"
          [attr.aria-label]="translate('nav.notifications')">
          <i class="fas fa-bell" id="header-notification-icon" aria-hidden="true"></i>
          <span *ngIf="unreadNotificationsCount > 0" class="notification-badge" id="header-notification-badge">{{ unreadNotificationsCount }}</span>
        </button>

        <!-- Notification dropdown -->
        <div class="notification-dropdown" *ngIf="showNotifications" id="header-notification-dropdown">
          <div class="notification-header" id="header-notification-header">
            <h3 id="header-notification-title">{{ translate('notifications.title') }}</h3>
            <button class="mark-all-btn" (click)="markAllAsRead()" id="header-notification-mark-all">{{ translate('notifications.markAllRead') }}</button>
          </div>

          <div class="notification-list" id="header-notification-list">
            <div *ngIf="notifications.length === 0" class="no-notifications" id="header-notification-empty">
              {{ translate('notifications.empty') }}
            </div>

            <div *ngFor="let notification of notifications; let i = index" class="notification-item"
              [ngClass]="{ 'unread': !notification.read, 'priority-high': notification.priority === 'high' }"
              (click)="markAsRead(notification.id)" id="header-notification-item-{{i}}">
              <div class="notification-icon" [ngClass]="notification.type" id="header-notification-icon-{{i}}">
                <i class="fas" [ngClass]="{
                  'fa-info-circle': notification.type === 'info',
                  'fa-exclamation-triangle': notification.type === 'alert',
                  'fa-check-circle': notification.type === 'success',
                  'fa-exclamation-circle': notification.type === 'warning'
                }" id="header-notification-icon-inner-{{i}}"></i>
              </div>
              <div class="notification-content" id="header-notification-content-{{i}}">
                <p class="notification-message" id="header-notification-message-{{i}}">{{ notification.message }}</p>
                <span class="notification-time" id="header-notification-time-{{i}}">{{ notification.timestamp | date:'short' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Theme toggle. Un solo `async` para no abrir una suscripcion por binding. -->
      <ng-container *ngIf="themeService.currentTheme$ | async as currentTheme">
        <button
          type="button"
          class="theme-btn"
          id="header-theme-btn"
          [title]="themeToggleLabel(currentTheme)"
          [attr.aria-label]="themeToggleLabel(currentTheme)"
          [attr.aria-pressed]="currentTheme === 'dark'"
          (click)="toggleTheme()">
          <i
            class="fas"
            [class.fa-sun]="currentTheme === 'dark'"
            [class.fa-moon]="currentTheme === 'light'"
            id="header-theme-icon"
            aria-hidden="true"></i>
        </button>
      </ng-container>

      <!-- Help -->
      <button class="help-btn" title="{{ translate('header.help') }}" id="header-help-btn"
        [attr.aria-label]="translate('nav.help')">
        <i class="fas fa-question-circle" id="header-help-icon" aria-hidden="true"></i>
      </button>

      <!-- User profile -->
      <div class="user-profile" [class.show-dropdown]="showUserMenu" id="header-user-profile">
        <div class="user-avatar"
          [style.backgroundImage]="'url(' + (currentUser?.avatar || 'assets/images/default-avatar.png') + ')'" id="header-user-avatar">
        </div>

        <div class="user-info" id="header-user-info">
          <span class="user-name" id="header-user-name">{{ currentUser?.name || 'Usuario' }}</span>
          <span class="user-role" id="header-user-role">
            {{
            currentUser?.role === 'admin' ? translate('role.admin') :
            currentUser?.role === 'executive' ? translate('role.executive') :
            translate('role.user')
            }}
          </span>
        </div>

        <div class="user-menu-wrapper" id="header-user-menu-wrapper">
          <button class="dropdown-toggle" (click)="toggleUserMenu()" id="header-user-menu-toggle"
            [attr.aria-label]="translate('nav.userMenu')">
            <i class="fas fa-chevron-down" id="header-user-menu-chevron" aria-hidden="true"></i>
          </button>

          <!-- Dropdown con *ngIf para evitar errores -->
          <div class="dropdown-menu" *ngIf="showUserMenu" id="header-user-menu-dropdown">
            <a routerLink="/profile" id="header-user-menu-profile">
              <i class="fas fa-user" id="header-user-menu-profile-icon"></i> {{ translate('nav.profile') }}
            </a>
            <a routerLink="/plan" id="header-user-menu-usage">
              <i class="fas fa-gauge-high" id="header-user-menu-usage-icon"></i> {{ translate('nav.plan') }}
            </a>
            <a routerLink="/preferencias" id="header-user-menu-settings">
              <i class="fas fa-cog" id="header-user-menu-settings-icon"></i> {{ translate('nav.settings') }}
            </a>
            <div class="dropdown-divider" id="header-user-menu-divider"></div>
            <a (click)="logout()" id="header-user-menu-logout">
              <i class="fas fa-sign-out-alt" id="header-user-menu-logout-icon"></i> {{ translate('nav.logout') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
